import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import b_ from 'b_';

import {Textinput} from 'client/common/components/lego';
import {changeNameFilter} from 'client/common/store/reducers/surveys';
import {getSurveyFilter} from 'client/common/store/selectors/surveys';

import SearchIcon from './icons/search.svg';

import './survey-name-filter.css';

const b = b_.with('survey-name-filter');

interface ComponentProps {
    mix?: string;
}

export default function SurveyNameFilter(props: ComponentProps) {
    const {mix = ''} = props;
    const dispatch = useDispatch();

    const className = `${b()} ${mix}`;

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        dispatch(changeNameFilter({name: e.target.value}));
    };
    const {name: nameFilter} = useSelector(getSurveyFilter);

    return (
        <div className={className}>
            <Textinput
                className={b('input')}
                value={nameFilter}
                size='m'
                view='default'
                type='text'
                name='search-query'
                onChange={handleChange}
                hasClear
                iconLeft={<img src={SearchIcon} className={b('search-icon')} />}
            />
        </div>
    );
}
